import type { IFirstClientMountService } from '@services/FirstClientMountService';
import { iocNames } from '../iocNames';
import { useInject } from './useInject';

export const useFirstClientMount = () => {
  return useInject<IFirstClientMountService>(iocNames.firstClientMountService);
};
